module.exports = __webpack_public_path__ + "d40761f21eebb19082ad74bd401555ee.svg";